import { EmployeeNodeModelAPI } from '../../../../models';
import { getEmployeeNodesAdapter } from '../../Adapters';
import { requests } from '../apiAgent';

export const EmployeesAPI = {
    getContractors: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/contractors')
            .then((response: EmployeeNodeModelAPI[]) =>
                getEmployeeNodesAdapter(response)
            );
    },

    getEmployees: (withContractors: boolean) => {
        return requests
            .get(
                `/jerusalem/api/v2.0.0/employees?includeContractors=${withContractors}`
            )
            .then((response: EmployeeNodeModelAPI[]) => {
                return getEmployeeNodesAdapter(response);
            });
    },
};
